import typewriter from "@/directives/typewriter";
import intersect from "@/directives/intersect";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("typewriter", typewriter);
  nuxtApp.vueApp.directive("intersect", intersect);
});
